'use strict';

var padLeft = function(string, paddingValue) {
  return String(paddingValue + string).slice(string.length);
};

/**
 * @see http://stackoverflow.com/q/7616461/940217
 * @return {number}
 */
var hashCode = function(str){
  if (Array.prototype.reduce){
    return str.split("").reduce(function(a,b){
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a
    }, 0);
  } 
  var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
    var character  = str.charCodeAt(i);
    hash  = ((hash<<5)-hash)+character;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

module.exports = {
  padLeft: padLeft,
  hashCode: hashCode
};



//////////////////
// WEBPACK FOOTER
// ./lib/string.js
// module id = 30
// module chunks = 1 3